import { maskDate } from 'util/masks';

import AssignmentIcon from '@mui/icons-material/Assignment';
import CreateIcon from '@mui/icons-material/Create';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, Stack, TableCell, TableRow, Tooltip } from '@mui/material';
import { ITreatmentConsultation, TreatmentConsultationTypeEnum } from 'types';

interface Props {
  consultation: ITreatmentConsultation;
  editable?: boolean;
  onViewPrescriptionClick: () => void;
  onViewConsultationClick: () => void;
  onEditClick: () => void;
}

export const TreatmentConsultationRow: React.FC<Props> = ({
  consultation,
  editable,
  onEditClick,
  onViewPrescriptionClick,
  onViewConsultationClick,
}) => {
  const { createdAt, vet, consultType, prescription } = consultation ?? {};

  return (
    <TableRow hover>
      <TableCell component="th" scope="row">
        {maskDate(createdAt)}
      </TableCell>

      <TableCell>{TreatmentConsultationTypeEnum[consultType]}</TableCell>

      <TableCell>{vet?.name}</TableCell>

      <TableCell>
        <Stack flexDirection="row" justifyContent="flex-end" gap="8px">
          {editable ? (
            <Tooltip title="Editar">
              <IconButton
                aria-label="edit"
                color="inherit"
                onClick={onEditClick}
              >
                <CreateIcon />
              </IconButton>
            </Tooltip>
          ) : null}

          {prescription?.length ? (
            <Tooltip title="Ver prescrição">
              <IconButton
                aria-label="delete"
                color="inherit"
                onClick={onViewPrescriptionClick}
              >
                <AssignmentIcon />
              </IconButton>
            </Tooltip>
          ) : null}

          <Tooltip title="Ver mais">
            <IconButton
              aria-label="view"
              color="inherit"
              onClick={onViewConsultationClick}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      </TableCell>
    </TableRow>
  );
};
